// removed by extract-text-webpack-plugin
module.exports = {"base":"_2BvUY","hide":"_2sEcg","message":"_1gzo8","info":"M9KYm","error":"_19d1X","noteIcon":"_36_UC","noteText":"_1Plo7","noteLink":"_3apRx","closebtn":"_3KfwN","button":"_3-953","add":"_2VZ1z","tip":"_2JZOb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Alert/Alert.scss
// module id = 1864
// module chunks = 0